import __var_0__ from './main.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Return a boolean indicating if an array is compatible with a single memory segment.
*
* @module @stdlib/ndarray/base/assert/is-single-segment-compatible
*
* @example
* var isSingleSegmentCompatible = require( '@stdlib/ndarray/base/assert/is-single-segment-compatible' );
*
* var shape = [ 2, 2 ];
* var strides = [ 2, 1 ];
* var offset = 0;
*
* var bool = isSingleSegmentCompatible( shape, strides, offset );
* // returns true
*
* @example
* var isSingleSegmentCompatible = require( '@stdlib/ndarray/base/assert/is-single-segment-compatible' );
*
* var shape = [ 10 ];
* var strides = [ 3 ];
* var offset = 0;
*
* var bool = isSingleSegmentCompatible( shape, strides, offset );
* // returns false
*/

// MODULES //
var isSingleSegmentCompatible = __var_0__;


// EXPORTS //
export default isSingleSegmentCompatible;
